import { motion } from "framer-motion";
import usePrefersReducedMotion from "./usePrefersReducedMotion";

const ease = [0.22, 1, 0.36, 1];

/**
 * Scroll / mount reveal. Use on section heroes, cards, and staggered lists.
 */
export default function Reveal({
  children,
  className = "",
  delay = 0,
  y = 28,
  x = 0,
  once = true,
}) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once, margin: "-8% 0px -8% 0px", amount: 0.2 }}
      transition={{ duration: 0.4, delay, ease }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", delay = 0, stagger = 0.06, animateOnMount = false }) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return <div className={className}>{children}</div>;
  }

  const motionProps = animateOnMount
    ? { animate: "show" }
    : {
        whileInView: "show",
        viewport: { once: true, margin: "-6% 0px", amount: 0.15 },
      };

  return (
    <motion.div
      className={className}
      initial="hidden"
      {...motionProps}
      variants={{
        hidden: {},
        show: {
          transition: { staggerChildren: stagger, delayChildren: delay },
        },
      }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", y = 22 }) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        show: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.35, ease },
        },
      }}
    >
      {children}
    </motion.div>
  );
}
